// src/api/config.ts

/**
 * API base URL handling
 * 
 * - In dev: fetch('/api/...') → Vite proxy → http://localhost:4000
 * - In prod: fetch('/api/...') → Nginx proxy → http://127.0.0.1:4000
 * - If you REALLY need an absolute URL, set VITE_API_URL in .env
 */
const explicit = (import.meta.env.VITE_API_URL || "").trim().replace(/\/$/, "");

export const API_BASE = explicit || ""; 
// Empty string = same-origin, so frontend just calls "/api/..."
